<template>
  <div class="register-page">
    <div class="register-card">
      <h2 class="page-title">用户注册</h2>
      <p class="page-subtitle">请填写完整信息完成注册</p>

      <form @submit.prevent="handleSubmit" novalidate>
        <div class="mb-3">
          <label class="form-label">用户名</label>
          <input
            v-model.trim="form.username"
            type="text"
            class="form-control custom-input"
            placeholder="5-10位数字和字母组合"
          />
          <small v-if="errors.username" class="error-text">{{ errors.username }}</small>
        </div>

        <div class="mb-3">
          <label class="form-label">密码</label>
          <input
            v-model.trim="form.password"
            type="password"
            class="form-control custom-input"
            placeholder="6-10位数字和字母组合"
          />
          <small v-if="errors.password" class="error-text">{{ errors.password }}</small>
        </div>

        <div class="mb-3">
          <label class="form-label">手机号</label>
          <input
            v-model.trim="form.phone"
            type="text"
            class="form-control custom-input"
            placeholder="请输入11位手机号"
          />
          <small v-if="errors.phone" class="error-text">{{ errors.phone }}</small>
        </div>

        <div class="mb-3">
          <label class="form-label">邮箱</label>
          <input
            v-model.trim="form.email"
            type="text"
            class="form-control custom-input"
            placeholder="请输入邮箱地址"
          />
          <small v-if="errors.email" class="error-text">{{ errors.email }}</small>
        </div>

        <div class="mb-3">
          <label class="form-label">省份</label>
          <select v-model="form.province" class="form-select custom-input">
            <option value="">请选择省份</option>
            <option v-for="p in provinceOptions" :key="p" :value="p">{{ p }}</option>
          </select>
          <small v-if="errors.province" class="error-text">{{ errors.province }}</small>
        </div>

        <div class="mb-3">
          <label class="form-label">地市</label>
          <select v-model="form.city" class="form-select custom-input" :disabled="!form.province">
            <option value="">请选择地市</option>
            <option v-for="c in cityOptions" :key="c" :value="c">{{ c }}</option>
          </select>
          <small v-if="errors.city" class="error-text">{{ errors.city }}</small>
        </div>

        <div class="mb-3">
          <label class="form-label">验证码</label>
          <div class="d-flex gap-2">
            <input
              v-model.trim="form.captcha"
              type="text"
              class="form-control custom-input"
              placeholder="请输入6位验证码"
            />
            <button type="button" class="btn captcha-btn" @click="generateCaptcha">
              {{ generatedCaptcha }}
            </button>
          </div>
          <small v-if="errors.captcha" class="error-text">{{ errors.captcha }}</small>
        </div>

        <button type="submit" class="btn register-btn w-100 mt-2">立即注册</button>
      </form>

      <div class="login-link mt-3">
        已有账号？
        <a href="javascript:void(0)" @click.prevent="goLogin">去登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import { provinceCityMap, provinceOptions } from '../utils/chinaRegions'

export default {
  name: 'RegisterView',
  data() {
    return {
      form: {
        username: '',
        password: '',
        phone: '',
        email: '',
        province: '',
        city: '',
        captcha: ''
      },
      generatedCaptcha: '',
      errors: {
        username: '',
        password: '',
        phone: '',
        email: '',
        province: '',
        city: '',
        captcha: ''
      }
    }
  },
  created() {
    this.generateCaptcha()
  },
  computed: {
    provinceOptions() {
      return provinceOptions
    },
    cityOptions() {
      return provinceCityMap[this.form.province] || []
    }
  },
  watch: {
    'form.province'(v) {
      if (!v) {
        this.form.city = ''
        return
      }
      const list = provinceCityMap[v] || []
      if (!list.includes(this.form.city)) {
        this.form.city = list[0] || ''
      }
    }
  },
  methods: {
    goLogin() {
      window.location.hash = '#/'
    },
    generateCaptcha() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'
      let value = ''
      for (let i = 0; i < 6; i += 1) {
        value += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.generatedCaptcha = value
    },
    validate() {
      const usernameRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{5,10}$/
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,10}$/
      const phoneRegex = /^1\d{10}$/
      const emailRegex = /^[A-Za-z\d._%+-]+@[A-Za-z\d.-]+\.[A-Za-z]{2,}$/
      const captchaRegex = /^[A-Za-z\d]{6}$/

      this.errors.username = ''
      this.errors.password = ''
      this.errors.phone = ''
      this.errors.email = ''
      this.errors.province = ''
      this.errors.city = ''
      this.errors.captcha = ''

      if (!usernameRegex.test(this.form.username)) {
        this.errors.username = '用户名需为5-10位且包含数字和字母'
      }
      if (!passwordRegex.test(this.form.password)) {
        this.errors.password = '密码需为6-10位且包含数字和字母'
      }
      if (!phoneRegex.test(this.form.phone)) {
        this.errors.phone = '手机号格式不正确，请输入11位手机号'
      }
      if (!emailRegex.test(this.form.email)) {
        this.errors.email = '邮箱格式不正确'
      }

      if (!this.form.province) {
        this.errors.province = '省份不能为空'
      }
      if (!this.form.city) {
        this.errors.city = '地市不能为空'
      }
      if (!captchaRegex.test(this.form.captcha)) {
        this.errors.captcha = '验证码需为6位数字和字母组合'
      } else if (
        this.form.captcha.toLowerCase() !== this.generatedCaptcha.toLowerCase()
      ) {
        this.errors.captcha = '验证码错误，请重新输入'
      }

      return (
        !this.errors.username &&
        !this.errors.password &&
        !this.errors.phone &&
        !this.errors.email &&
        !this.errors.province &&
        !this.errors.city &&
        !this.errors.captcha
      )
    },
    handleSubmit() {
      if (!this.validate()) {
        return
      }
      fetch('/api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': '1'
        },
        body: JSON.stringify({
          username: this.form.username,
          password: this.form.password,
          phone: this.form.phone,
          email: this.form.email,
          province: this.form.province,
          city: this.form.city
        })
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.code === 200) {
            localStorage.setItem(
              'exam_user',
              JSON.stringify({
                username: this.form.username,
                role: 'student',
                phone: this.form.phone
              })
            )
            window.alert('注册成功，即将跳转管理首页。')
            window.location.hash = '#/student/home'
            return
          }
          window.alert(res.message || '注册失败')
          this.generateCaptcha()
        })
        .catch(() => {
          window.alert('网络异常，请检查后端服务是否已启动')
        })
    }
  }
}
</script>

<style scoped>
.register-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at 12% 18%, rgba(78, 132, 255, 0.3), transparent 34%),
    radial-gradient(circle at 88% 24%, rgba(55, 188, 255, 0.22), transparent 30%),
    radial-gradient(circle at 70% 88%, rgba(120, 146, 255, 0.2), transparent 34%),
    linear-gradient(140deg, #081734 0%, #0c2450 45%, #0a1b3f 100%);
}

.register-page::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(rgba(131, 168, 255, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(131, 168, 255, 0.08) 1px, transparent 1px);
  background-size: 28px 28px;
  opacity: 0.4;
}

.register-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 460px;
  padding: 34px 30px;
  border-radius: 18px;
  background: rgba(9, 30, 68, 0.78);
  border: 1px solid rgba(141, 180, 255, 0.35);
  box-shadow: 0 22px 55px rgba(4, 16, 40, 0.55);
  backdrop-filter: blur(8px);
}

.page-title {
  margin: 0;
  text-align: center;
  color: #e5f0ff;
  font-size: 30px;
  letter-spacing: 1px;
}

.page-subtitle {
  margin: 10px 0 24px;
  text-align: center;
  color: #b8ccf7;
  font-size: 14px;
}

.form-label {
  color: #d5e3ff;
  margin-bottom: 8px;
}

.custom-input {
  background: rgba(11, 38, 86, 0.75);
  border: 1px solid rgba(126, 164, 245, 0.45);
  color: #edf4ff;
}

.custom-input::placeholder {
  color: #8ba8df;
}

.custom-input:focus {
  background: rgba(9, 34, 80, 0.9);
  border-color: #6ea0ff;
  box-shadow: 0 0 0 3px rgba(110, 160, 255, 0.25);
  color: #edf4ff;
}

.captcha-btn {
  min-width: 110px;
  border: none;
  background: linear-gradient(120deg, #2c71ef, #58a4ff);
  color: #ffffff;
  font-weight: 600;
}

.register-btn {
  border: none;
  background: linear-gradient(120deg, #2f6feb, #62aaff);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 0;
}

.register-btn:hover {
  background: linear-gradient(120deg, #3b7bf1, #73b4ff);
}

.error-text {
  color: #ffc2c2;
  font-size: 12px;
}

.login-link {
  color: #c4d8ff;
  text-align: center;
  font-size: 14px;
}

.login-link a {
  color: #8fc0ff;
  text-decoration: none;
}

.login-link a:hover {
  text-decoration: underline;
}
</style>
